import { v4 as uuidv4 } from 'uuid'
import { getBetslipLogDetails } from '@nsftx/seven-client-retail-vue-sgp'
import { logService } from '@nsftx/seven-client-retail-utils'
import type { PrintContextPayinSlip } from '@nsftx/seven-client-retail-print'
import { useNotificationsStore } from '@nsftx/seven-nxg-retail-vue-sdk'
import type { BetslipView } from '@nsftx/seven-client-retail-vue-integrator'
import errorParser from '@/utils/errorParser'
import i18n from '@/plugins/translationsPlugin'
import printService from '../print/services/printService'

const LOG_PREFIX = '[slipCopyService]'
const { t } = i18n.global

const printSlipCopy = async (betslip: BetslipView) => {
  const { feBetslipId, linkCode } = betslip.context

  logService.debug(`${LOG_PREFIX} Print copy action was called.`, {
    code: 'SS_PRINT_COPY_PERFORM_ACTION',
    feBetslipId,
    product_displayid: linkCode,
  })

  try {
    const printContext: PrintContextPayinSlip = {
      model: {
        slip: betslip,
      },
      meta: {
        requestId: uuidv4(),
        productDisplayId: linkCode,
        isCopy: true,
      },
    }
    await printService
      .getPrintService()
      .performPrint(`games${linkCode}`, 'betslip_payin', printContext)

    logService.debug(`${LOG_PREFIX} Print copy action was successful.`, {
      code: 'SS_PRINT_COPY_SUCCESS',
      ...getBetslipLogDetails(betslip),
    })
  } catch (error) {
    const { showNotification } = useNotificationsStore()
    logService.error(`${LOG_PREFIX} Failed to perform print copy action.`, {
      code: 'SS_PRINT_COPY_ERROR',
      ...errorParser.parseUpstream(error),
    })
    showNotification({
      variant: 'error',
      text: [t('slip_print_copy_failed')],
    })
  }
}

export { printSlipCopy }
